import VTableCard from '@/vuetify_custom/v-table-card'
import VRippleCol from '@/vuetify_custom/v-ripple-col';
import {company_consistency_list_hash} from '@/views/openShopApply/fields.js'
import { getsafe } from '@/libs/util.js'
import { VSpacer } from 'vuetify/lib'
export default {
    props: {
        item: {
            type: Object,
            default: () => ({})
        },
        target: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        tableCardFields() {
            return [
                 {
                     key: 'company_consistency'
                 }
            ]
        }
    },
    methods: {
        displayF(str) {
            if (!str || !str.split) {
                return <span>{str}</span>
            }
            const str_arr = str.split(',')
            return <div>
                {str_arr.map(i => {
                    const color = getsafe(company_consistency_list_hash, `${i}.color`, '')
                    return <p style={`margin-bottom:0px;color: ${color}`}>
                    {i}
                    </p>
                })}
            </div>
        }
    },
    render() {
        const _this = this
        return <VTableCard 
                    sub-title="税务信息"
                    value={_this.target}
                    fields={_this.tableCardFields}
                    cols={12}
                    scopedSlots={{
                        company_consistency({ value}) {
                            const company_consistency = value.company_consistency
                        
                          
                            return <div style={{width: '100%'}}>
                                  <VRippleCol cols={12}>
                                    {/* <VRippleCol cols={12}> */}
                                    主体信息：
                                        <VSpacer/>
                                   {/* </VRippleCol>    */}
                                   <div>
                                    {_this.displayF(company_consistency)}
                                   </div>
                                   </VRippleCol>
                            {/* { 
                            company_consistency.map(child => {
                                return <VRippleCol cols={12}>
                                    <span style="white-space:nowrap">{child.material_name}</span>
                                    <VSpacer/>
                                    {this.displayF()}
                                   <p 
                                    style={{
                                        margin:'0 0 0 20px'
                                    }}
                                   >
                                        {child && child.labels && child.labels.map((label, index) => <p>{`${label}:${child.values && child.values[index] || '-'}`}</p>)}
                                    </p> 
                                </VRippleCol>
                              
                            })} */}
                            </div> 
                           
                            
                        }
                    }}
                />
    }
}